import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface TestimonialCardProps {
  name: string;
  location: string;
  text: string;
  avatar: string;
  rating?: number;
  occasion?: string;
}

export function TestimonialCard({
  name,
  location,
  text,
  avatar,
  rating = 5,
  occasion,
}: TestimonialCardProps) {
  return (
    <Card className="p-5 hover:shadow-md transition-shadow duration-200">
      <CardContent className="p-0 flex flex-col gap-3">
        <div className="flex items-center gap-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star
              key={i}
              className={`h-4 w-4 ${i < rating ? "text-[#F59E0B] fill-[#F59E0B]" : "text-gray-200"}`}
            />
          ))}
          {occasion && (
            <span className="ml-1 text-[10px] text-gray-400 font-medium">• {occasion}</span>
          )}
        </div>

        <p className="text-sm text-gray-600 leading-relaxed italic">"{text}"</p>

        <div className="flex items-center gap-3 pt-1">
          <div className="h-9 w-9 rounded-full bg-gradient-to-br from-[#E11D48] to-[#881337] flex items-center justify-center text-white font-bold text-sm shrink-0">
            {avatar}
          </div>
          <div>
            <p className="text-sm font-semibold text-[#1F2937]">{name}</p>
            <p className="text-xs text-gray-400">{location}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
